import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP8NrNew202604: FaireAdPerformancePeriodEntity = {
  token: "perf_p8_nr_new_202604",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-04-01",
  endDate: "2026-04-30",
  impressions: 36184,
  clicks: 699,
  adsSpendDollars: 3750,
  budgetDollars: 6000,
  salesDollars: 19765,
  bestEstimateRoas: 5.27,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.63,
  newCustomersAcquired: 47,
  dataAvailableAtDate: "2026-05-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
